const files = {};
export const fileStorage = {
    clear: () => {
        Object.keys(files).forEach(key => delete files[key]);
    },
    removeFile: (id) => {
        files[id] = null;
    },
    setFile: (id, file) => {
        files[id] = file;
    },
};
